/**
 * Reine Math-Helpers fuer StayStream — extrahiert um die Component unter 150 Zeilen zu halten.
 */
import type { BookingResponse } from '@/shared/api';
import { formatAccommodationPrice } from '@/shared/lib/bookingPrice';

export interface StreamSegment {
  id: string;
  leftPercent: number;
  widthPercent: number;
  channel: string;
  source: 'Manuell' | 'Ota';
  status: BookingResponse['status'];
  priceLabel: string;
  checkIn: string;
  checkOut: string;
}

export function daysBetween(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / 86400000);
}

export function toSegment(b: BookingResponse, from: Date, totalDays: number): StreamSegment {
  const checkIn = new Date(b.checkInDate);
  const checkOut = new Date(b.checkOutDate);
  const dayOffset = Math.max(0, daysBetween(from, checkIn));
  const stayDays = Math.max(1, daysBetween(checkIn, checkOut));
  return {
    id: b.id,
    leftPercent: (dayOffset / totalDays) * 100,
    widthPercent: (stayDays / totalDays) * 100,
    channel: b.source === 'Manuell' ? 'Manuell' : (b.channel ?? 'Unknown'),
    source: b.source,
    status: b.status,
    priceLabel: formatAccommodationPrice(b),
    checkIn: b.checkInDate,
    checkOut: b.checkOutDate,
  };
}

export function channelMatches(channel: string, highlight: string): boolean {
  return channel.toLowerCase() === highlight.toLowerCase();
}

export function monthLabelsBetween(from: Date, to: Date): string[] {
  const labels: string[] = [];
  const cursor = new Date(from.getFullYear(), from.getMonth(), 1);
  while (cursor <= to) {
    labels.push(cursor.toLocaleDateString('de-DE', { month: 'short' }));
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return labels;
}

export function computeTodayPercent(from: Date, to: Date, totalDays: number): number | null {
  const today = new Date();
  if (today < from || today > to) return null;
  return (daysBetween(from, today) / totalDays) * 100;
}
